import { Dispatch, SetStateAction, useState } from 'react';
import { Alert, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../../../../components/confirm-modal/ConfirmModal';
import { ReactComponent as ClipboardCheckIcon } from '../../../../../../assets/icons/layout-icons/ClipboardCheckIconEditModal.svg';
import { primaryLight } from '../../../../../../utils/color';
import useUpdate from '../../../../../../utils/hooks/crud-hooks/useUpdate';

type RevokeModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onSuccessfulSubmit?: () => void;
  invitationId: string;
};

const RevokeModal = ({ isOpen, setIsOpen, onSuccessfulSubmit, invitationId }: RevokeModalProps) => {
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation();
  const { mutate: revoke, isLoading } = useUpdate({
    resource: 'user-invitation',
  });

  const onSubmit = () => {
    revoke(
      {
        id: invitationId,
        suffix: 'revoke',
      },
      {
        onSuccess: () => {
          setError(null);
          setIsOpen(false);
          onSuccessfulSubmit?.();
        },
        onError: (err) => {
          setError((err as any).response?.data.message || (err as any).message);
        },
      },
    );
  };

  return (
    <ConfirmModal
      isModalOpen={isOpen}
      automaticallyCloseModalOnButtonClick={false}
      onCancel={() => setIsOpen(false)}
      onConfirm={onSubmit}
      setIsModalOpen={() => null}
      title={t('settings.members.revokeInvitation')}
      width="900px"
      confirmButtonText={t('common.revoke')}
      iconProps={{
        icon: <ClipboardCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: '#E3DBFC',
      }}
      isLoading={isLoading}
      showCancelButton={!isLoading}
      message={
        <Stack spacing={3}>
          {error && (
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
          <Typography variant="body2">{t('settings.members.revokeInvitationModalText')}</Typography>
        </Stack>
      }
    />
  );
};

export default RevokeModal;
